import React from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Alert from "@mui/material/Alert";

import Button from "../shared/Button";

const ErrorUpload = ({ handleClose }) => {
  return (
    <Stack alignItems="center" pl={5} pr={1} py={5}>
      <img src="/assets/icons/incomplete-mapping.svg" alt="" />
      <Typography color="var(--text-color)" fontSize={24} fontWeight={700}>
        Mapping incomplet
      </Typography>
      <Alert
        icon={false}
        severity="error"
        sx={{
          mt: 3,
          px: 5,
          py: 2,
          mb: 4,
          border: "1px solid var(--red-color)",
        }}
      >
        <Stack direction="row" alignItems="center">
          <Stack mr={3}>
            <Stack
              sx={{
                borderBottom: "1px solid var(--light-grey-text)",
                pb: 2,
                mb: 2,
              }}
            >
              <Typography
                color="var(--text-color)"
                fontSize={17}
                fontWeight={700}
              >
                Informations incomplètes
              </Typography>
              <Typography
                color="var(--text-color)"
                fontSize={14}
                fontWeight={500}
              >
                Certains champs sont requis avant de confirmer le Mapping.
              </Typography>
            </Stack>
            <Typography
              color="var(--light-grey-text)"
              fontSize={14}
              fontWeight={500}
            >
              Certains champs sont requis avant de valider l'association.
              Assurez-vous que le nom du document, le type, la date de
              publication et le bien immobilier soient correctement remplis.
            </Typography>
          </Stack>
          <img src="/assets/icons/warning-error.svg" alt="" />
        </Stack>
      </Alert>
      <Button onClick={handleClose}>Retour</Button>
    </Stack>
  );
};

export default ErrorUpload;
